<script>
// assets/project/src/components/Base/TinymceEditor3.vue
import Editor from '@tinymce/tinymce-vue';
import tinymce from 'tinymce/tinymce';
import "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "~/tiny-plugins/tinymce-line-height-plugin-master/lineheight";

export default {
	name: "TinymceEditor",
	components: {
		'editor': Editor,
	},
	props: {
		'id': {},
		'label': {},
		'value': {},
		'objectKey': {},
		'parentKey': {},
		'description': {},
		'isDataUpdating': {},
		'modelValue': {},
		'max_chars': {},
		'min_chars': {},
		'isRequired': {default: false}
	},
	data() {
		return {
			currentValue: this.modelValue,
			allowedKeys: [8, 37, 38, 39, 40, 46], // backspace, delete and cursor keys,
		}
	},
	mounted() {
		this.currentValue = this.modelValue;
	},
	methods: {
		saveData() {
			
			if (this.min_chars && this.tinymce_getContentLength < parseInt(this.min_chars)) {
				return; // Не эмитим событие, если не достигнуто минимальное количество символов
			}
			
			if (this.max_chars && this.tinymce_getContentLength < parseInt(this.max_chars)) {
				this.$emit('onChange')
			}
			if (!this.max_chars) {
				this.$emit('onChange')
			}
		},
		changeData(e) {
			// Получаем длину контента после изменения
			const contentLength = this.extractContent(this.currentValue).length;
			
			if (this.min_chars) {
				if (contentLength < this.min_chars) {
					this.$emit('update:modelValue', '');
					return;
				}
			}
			if (this.max_chars) {
				// Проверка на максимальное количество символов
				if (this.allowedKeys.indexOf(e.keyCode) != -1 || contentLength < parseInt(this.max_chars)) {
					// Проверяем минимальное количество символов
					if (!this.min_chars || contentLength >= parseInt(this.min_chars)) {
						this.$emit('update:modelValue', this.currentValue)
					}
				} else {
					e.preventDefault();
					e.stopPropagation();
				}
			} else {
				this.$emit('update:modelValue', this.currentValue)
			}
		},
		extractContent(s) {
			var span = document.createElement('span');
			span.innerHTML = s;
			return span.textContent || span.innerText;
		},
		
	},
	computed: {
		showMinCharsError() {
			return this.min_chars ?
				(this.tinymce_getContentLength > 0 && this.tinymce_getContentLength < parseInt(this.min_chars))
				: false;
		},
		isFieldRequired() {
			if (typeof this.$parent.isFieldRequired === 'function') {
				return this.$parent.isFieldRequired(this.objectKey);
			} else {
				return this.isRequired;
			}
		},
		tinymce_getContentLength() {
			if (this.id && this.currentValue) {
				return this.extractContent(this.currentValue).length;
			} else {
				return 0;
			}
		}
	},
	watch: {
		modelValue(val) {
			if (this.min_chars) {
				if (this.extractContent(val).length > this.min_chars) {
					this.currentValue = val;
				}
			} else {
				this.currentValue = this.modelValue;
			}
		}
	}
}
</script>

<template>
	
	<div class="field">
		<label :class="isFieldRequired || isRequired ? 'req' : ''"> {{ label }}</label>
		<p class="field_description" v-if="description">{{ description }}</p>
		<div class="min_max_block" v-if="id">
			<p class="contentLength">Количество символов: {{ tinymce_getContentLength }}</p>
			<p v-if="min_chars" class="contentLength">Минимальное количество символов: {{ min_chars }}</p>
			<p v-if="max_chars" class="contentLength">Максимальное количество символов: {{ max_chars }}</p>
		</div>
		<p v-if="min_chars" class="error-message">
			Внимание! Текст не будет сохранен, пока количество символов меньше {{ min_chars }}
		</p>
		<p>Для вставки текста используйте сочетание клавиш Ctrl + V на клавиатуре</p>
		<editor
			:disabled="isDataUpdating"
			:id="id"
			@blur="saveData"
			:init="{
                  plugins: 'lists link visualchars paste code textcolor fullscreen lineheight',
                  menubar:false,
                  paste_as_text: true,
                  paste_remove_styles: true,
						      setup: (editor) => {
					            // Добавляем обработчик перед вставкой
					            editor.on('PastePreProcess', (e) => {
					               const currentContent = editor.getContent({format: 'text'});
					               const totalLength = currentContent.length + e.content.length;
					               
					               if (this.max_chars && totalLength > parseInt(this.max_chars)) {
					                  e.content = '';
					               }
					            });
					         },
                  toolbar: 'undo redo | blocks | bold italic forecolor backcolor fontselect fontsizeselect | lineheightselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent paste code fullscreen',
                  font_formats: 'PT-Root-UI=PT Root UI, sans-serif; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;'
                }"
			v-model="currentValue"
			@change="changeData"
			@keyPress="changeData"
			@nodeChange="changeData"
		></editor>
	</div>
</template>

<style scoped>
.field_description, .contentLength {
	font-size: 13px;
}

.min_max_block {
	display: flex;
	gap: 30px;
}
.error-message {
	color: #ff0000;
	font-size: 13px;
	margin-top: 5px;
	margin-bottom: 5px;
}
</style>